import { HeaderComponent } from './header/header.component';
import { BannerComponent } from './banner/banner.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { OptionItemComponent } from './option-item/option-item.component';
import { MailInfoComponent } from './mail-info/mail-info.component';
import { NewsItemComponent } from './news-item/news-item.component';
import { PdfItemComponent } from './pdf-item/pdf-item.component';
import { LinksComponent } from './usefull-links/links/links.component';
import { PaymentFlyerDetailsComponent } from '../modals/payment-flyer-details/payment-flyer-details.component';

export const COMPONENTS = [
  HeaderComponent,
  BannerComponent,
  UserProfileComponent,
  OptionItemComponent,
  MailInfoComponent,
  NewsItemComponent,
  PdfItemComponent,
  LinksComponent,
  PaymentFlyerDetailsComponent
];
